module.exports = __webpack_public_path__ + "img/mj-bg.ff307950.png";